module.exports = __webpack_public_path__ + "images/cam-tour-81dd432a459c86e5f693431b51042fcb.png";